<ps-adjustment-table
  [adjustmentManualFixRecord]="manualFixList"
  [userId]="userId"
  [userName]="userName"
  [operationType]="operationType"
  [showDownloadReportButtoonInRecon]="true"
  [showBackToDashboardButton]="true"
></ps-adjustment-table>
